import { DetailTurnModalProps } from "./types";
import { GetOneAppointmentResponseService } from "../../../services/TurnServices/Turns.type";
import { Modal } from "../../../components/others/Modal";
import StyledWrapper from "./style";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import LavorisService from "../../../services/LavorisService";
import { useFetchOne } from "../../../hooks";
import { TagField } from "../../../components/others/TagField";
import {
  MoldeDetails,
  ExamDetails,
  PracticesList,
} from "../AppointmentMetadata";

const DetailTurnWithDateParticular: React.FC<DetailTurnModalProps> = ({
  closeModal,
  ...modalProps
}) => {
  const rowData = useFetchOne<GetOneAppointmentResponseService>("appointments");

  const LavorisInstance = LavorisService.getInstance();
  const files = rowData?.files;
  const fileArray = Array.isArray(files) ? files : [];

  const handleDownload = (fileId: string) => {
    LavorisInstance.FilesService.getAWSTurnFile(fileId);
  };

  if (!rowData)
    return (
      <Modal
        {...modalProps}
        titleStyle="text-2xl text-red-500 font-bold my-4"
        modalContainerStyle="max-w-lg"
      >
        <h1 className="w-full flex justify-center text-red-500 font-bolder animate-pulse">
          {" "}
          Cargando...{" "}
        </h1>
      </Modal>
    );

  return (
    <Modal
      {...modalProps}
      titleStyle="text-2xl text-red-500 font-bold my-4"
      modalContainerStyle="max-w-lg"
    >
      <div className="mb-4 max-w-lg">
        <div className="flex gap-10 items-center bg-[#F8F7F7] rounded-lg p-4">
          <div>
            <p>
              <span className="font-semibold text-lg">
                {rowData?.patient.name || "N/A"}
              </span>
            </p>
            <p>
              <StyledWrapper.ListItemCard>DNI:</StyledWrapper.ListItemCard>
              {rowData?.patient.DNI || "N/A"}
            </p>
            <p>
              <StyledWrapper.ListItemCard>
                Fecha de Nacimiento:
              </StyledWrapper.ListItemCard>
              {rowData?.patient.birthDate || "N/A"}
            </p>
            <p>
              <StyledWrapper.ListItemCard>Puesto:</StyledWrapper.ListItemCard>
              {"Cliente Particular"}
            </p>
          </div>
        </div>

        {rowData?.metadata.molde ? (
          <div className="flex flex-col max-w-lg">
            <StyledWrapper.ListItem>Molde:</StyledWrapper.ListItem>
            <div className="flex flex-wrap mb-3">
              <TagField className="bg-gray-300 font-bold">
                {rowData.metadata.molde.name || "No corresponde"}
              </TagField>
            </div>
            <MoldeDetails molde={rowData?.metadata.molde} />
          </div>
        ) : null}

        {rowData?.metadata.exam ? (
          <div className="flex flex-col max-w-lg">
            <StyledWrapper.ListItem>Examen:</StyledWrapper.ListItem>
            <div className="flex flex-wrap mb-3">
              <TagField className="bg-gray-300 font-bold">
                {rowData.metadata.exam.name}
              </TagField>
            </div>
            <ExamDetails exam={rowData.metadata.exam} />
          </div>
        ) : null}

        {rowData?.metadata.practices ? (
          <div className="flex flex-col max-w-lg mb-3">
            <StyledWrapper.ListItem>Prácticas:</StyledWrapper.ListItem>
            <PracticesList practices={rowData.metadata.practices} />
          </div>
        ) : null}

        <hr className="my-2" />
        <StyledWrapper.ListItem>
          Fecha y Hora:{" "}
          <span className="font-normal">
            {rowData?.date && rowData?.startTime
              ? `${rowData?.date} - ${rowData?.startTime}hs.`
              : "No corresponde"}
          </span>
        </StyledWrapper.ListItem>
        <hr className="my-2" />
        <StyledWrapper.ListItem>
          Estado: <span className="font-normal">{rowData?.status}</span>
        </StyledWrapper.ListItem>
        <hr className="my-2" />
        <StyledWrapper.ListItem>Comentarios:</StyledWrapper.ListItem>
        <p>{rowData?.observations || "Sin comentarios"}</p>
        <hr className="my-2" />
        <StyledWrapper.ListItem>Adjuntos:</StyledWrapper.ListItem>
        {fileArray.length > 0 ? (
          <ul className="list-none space-y-2 mt-2">
            {fileArray.map((file: { id: string; name?: string }) => (
              <li
                key={file.id}
                className="flex items-center justify-between gap-2 py-2 px-3 bg-gray-50 rounded border border-gray-200"
              >
                <span className="truncate text-sm" title={file.name || file.id}>
                  {file.name || file.id || "Archivo"}
                </span>
                <button
                  type="button"
                  onClick={() => handleDownload(file.id)}
                  className="inline-flex items-center gap-1 px-2 py-1 text-sm font-medium text-white bg-gray-800 rounded hover:bg-gray-700"
                >
                  Descargar
                  <FileDownloadOutlinedIcon sx={{ fontSize: 18 }} />
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-500 mt-2">No hay archivos adjuntos</p>
        )}
      </div>
    </Modal>
  );
};

export default DetailTurnWithDateParticular;
